/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "./Body.css";
import aibrokerbg from "../../Images/ai-broker-bgline.webp";
import htmlParser from "html-react-parser";
import { useEffect } from 'react'; // Import useEffect from 'react'
import {
  capitalizeFirstLetter,
  formatPhoneNumber,
  addInternationalCode,
} from "../Utils";
// Define scrollToProductSection outside of the Body component
const scrollToProductSection = () => {
  const productSection = document.getElementById('product-section');
  if (productSection) {
    let yOffset = -80; // Default offset for desktop

    if (window.matchMedia('(max-width: 820px)').matches) {
      yOffset = -25; // Offset for iPad (768 to 820)
    } else if (window.matchMedia('(max-width: 450px)').matches) {
      yOffset = -15; // Offset for mobile (320 to 450)
    }

    const y = productSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

export default function Body({loanOfficerData,bannerData }) {

  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "marketing-lo-website/";

  const loImage = loanOfficerData ? loanOfficerData.staff.loanOfficer.lobannerImage : "";
  const loanOfficerName = loanOfficerData ? capitalizeFirstLetter(loanOfficerData.staff.loanOfficer.loName) : "";
  const loanOfficerPhoneNumber = loanOfficerData ? (loanOfficerData.staff.loanOfficer.loPhone ? loanOfficerData.staff.loanOfficer.loPhone : loanOfficerData.loPhone) : "";
  const loanOfficerPhoneNumberFormatted = loanOfficerData ? formatPhoneNumber(loanOfficerPhoneNumber) : "";
  const loanOfficerPhoneNumberWithInternationalCode = loanOfficerData ? addInternationalCode(loanOfficerPhoneNumber, "+1") : "";
  const loanOfficerPhoneNumberInTitle = loanOfficerData ? "Contact me at " + loanOfficerPhoneNumberFormatted : "";

  


  return (
    <>
      <div className="banner">
        <Container>
        <Row className="banner-row">
            <Col sm={12} md={12} xl={12} xxl={12} lg={12} className="welcome-col">
              <div className="joaquinsec">
                {bannerData && bannerData.title && (
                  <>
                    <h1 className="title">{htmlParser(bannerData.title)}</h1>
                    <img src={aibrokerbg} alt="aibrokerbg" className="aibrokerbg-en" />
                    <h1 className="lo-website">{htmlParser(bannerData["lo-website"])}</h1>
                    <p className="banner-para">{htmlParser(bannerData["banner-para"])}</p>
                  </>
                )}
              </div>
            </Col>
          </Row>
          <Row className="banner-button-row">
            <div className="banner-button">
          <div>
              <a href={htmlParser(bannerData["signUp-url"])} target="_blank">
              <Button className="signupButton">{htmlParser(bannerData["signUp-Btn"])}</Button>
            </a>
            
              </div>
              <div>
             
              <Button className="ratesButton" onClick={scrollToProductSection}>{htmlParser(bannerData["viewRates-Btn"])}</Button>
          
              </div>
              </div>
          </Row>
        </Container>
      </div >
    </>
  );
}
